import * as types from "../actions/actionTypes";
import { loadSessionCache } from "../offline/sessionCache";
import { getCurrentSessionCode } from "../session/hostTokens";

// The songs of the current session keyed by song id. Ordering lives on each song's Sort.
const toMap = (songs) =>
  (Array.isArray(songs) ? songs : Object.values(songs || {})).reduce((map, song) => {
    map[song.Id] = song;
    return map;
  }, {});

/** The queue the device remembers for a session (see offline/sessionCache.js). */
const cachedSongs = (code) => toMap(loadSessionCache(code)?.songs || []);

// A function so the remembered session's cache is read when the store is created.
export const createInitialQueueState = () => cachedSongs(getCurrentSessionCode());

export default function queueReducer(state = createInitialQueueState(), action) {
  switch (action.type) {
    case types.QUEUE_LOAD_SUCCESS:
      return toMap(action.songs);

    case types.QUEUE_SONG_ADDED:
      return { ...state, [action.song.Id]: action.song };

    case types.QUEUE_SONG_REMOVED: {
      const { [action.songId]: removed, ...rest } = state;
      return removed ? rest : state;
    }

    case types.QUEUE_REORDERED: {
      const next = { ...state };
      action.songIds.forEach((id, index) => {
        if (next[id]) next[id] = { ...next[id], Sort: index + 1 };
      });
      return next;
    }

    case types.QUEUE_SONG_SUNG:
      return state[action.songId]
        ? { ...state, [action.songId]: { ...state[action.songId], Sung: action.sung } }
        : state;

    case types.QUEUE_SONG_TRANSPOSE:
      return state[action.songId]
        ? { ...state, [action.songId]: { ...state[action.songId], Transpose: action.transpose } }
        : state;

    case types.SONG_UPDATED:
      return state[action.song.Id]
        ? { ...state, [action.song.Id]: { ...state[action.song.Id], ...action.song } }
        : state;

    case types.SONG_DELETED: {
      const { [action.songId]: removed, ...rest } = state;
      return removed ? rest : state;
    }

    case types.SESSION_SET_CODE:
      return cachedSongs(action.code);

    case types.QUEUE_CLEARED:
    case types.SESSION_CLEAR:
      return {};

    default:
      return state;
  }
}
